const LOAD_DELETED_DEVICES = "deleted-device::load";
const LOAD_DELETED_DEVICES_FAILURE = "deleted-device::load::failure";
const LOAD_DELETED_DEVICES_SUCCESS = "deleted-device::load::success";

export {
  LOAD_DELETED_DEVICES,
  LOAD_DELETED_DEVICES_FAILURE,
  LOAD_DELETED_DEVICES_SUCCESS,
};
